import { render, staticRenderFns } from "./GameDetails.vue?vue&type=template&id=30f996b0"
import script from "./GameDetails.vue?vue&type=script&lang=js"
export * from "./GameDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports